export { default } from './UserMenuItem';



// WEBPACK FOOTER //
// ./src/components/base/UserMenuItem/index.js